import {
  JsonapiEntity,
  OneUnresolvedIdentifierOr,
  attribute,
  entity,
  relationship,
} from '@talisdev/jsonapi-transformers';

import {
  BibliographicResource,
  BibliographicResourceForActionApi,
  copyBibliographicResourceAttributes,
} from '®shared/bibliographic-resource';

@entity({ type: 'create_resource_actions' })
export class CreateResourceAction extends JsonapiEntity<CreateResourceAction> {
  @attribute() main: BibliographicResourceForActionApi;
  @attribute() container?: BibliographicResourceForActionApi;

  @relationship({ name: 'main', allowUnresolvedIdentifiers: true })
  mainRelationship?: BibliographicResource;

  @relationship({ name: 'container', allowUnresolvedIdentifiers: true })
  containerRelationship?: OneUnresolvedIdentifierOr<BibliographicResource>;
}

export function bibliographicResourceToCreateResourceAction(
  bibliographicResource: BibliographicResource,
): CreateResourceAction {
  const main = copyBibliographicResourceAttributes(bibliographicResource);
  const container = bibliographicResource.part_of
    ? copyBibliographicResourceAttributes(bibliographicResource.part_of)
    : null;

  return CreateResourceAction.create({
    main,
    container,
    mainRelationship: bibliographicResource,
    containerRelationship: bibliographicResource.part_of ?? null,
  });
}
